<template>
  <div class="gallery">
    <div class="close" @click="closeGallery">
      <TheClose />
    </div>
    <img class="contain" src="@/assets/img/steam.jpg" alt="" />
  </div>
</template>

<script setup lang="ts">
import { defineEmits } from "vue";
import TheClose from "@/components/icons/TheClose.vue";

const emit = defineEmits(["close"]);

function closeGallery() {
  emit("close");
}
</script>

<style scoped>
.gallery {
  position: fixed;
  top: 0;
  z-index: 99;
  bottom: 0;
  left: 0;
  right: 0;
  background: #050017;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-direction: column;
  max-width: 500px;
  margin: 0 auto;
  padding: 16px;
}
.contain {
  object-fit: contain;
  width: 100%;
  height: auto;
  margin: 0 auto;
}
.close {
  cursor: pointer;
}
</style>
